import { createFileRoute } from '@tanstack/react-router'
import EditionEducation from 'Edition/components/sections/Content/EditionEducation'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/content-education')({
    component: EditionEducation,
})
